@import "@/scss/use-bootstrap-mixins.scss";

button {
  border-radius: 14px;
  border: none;

  font-weight: 600;

  &:hover {
    cursor: pointer;
  }

  /**
    *
    *   Button themes
    *
    */
  &.primary {
    background-color: $primary;
    color: $textColorOnPrimary;
    border: 2px solid $primary;
  }

  &.textOnPrimary {
    background-color: #fff;
    color: #000;
    border: 2px solid #fff;
  }

  &.outlineOnPrimary {
    background-color: transparent;
    border: 2px solid $textColorOnPrimary;
    color: $textColorOnPrimary;
  }

  &.outlineOnBackground {
    background-color: transparent;
    border: 2px solid $primaryOnBackground;
    color: $primaryOnBackground;
  }

  &.primaryOnWhite {
    background-color: #fff;
    border: 2px solid #fff;
    color: $primaryOnBackground;
  }

  &.blackOnWhite {
    background-color: #fff;
    border: 2px solid #000;
    color: #000;
  }

  /**
    *
    *   Button sizes
    *
    */
  &.small {
    padding: 10px 14px;
    font-size: 14px;
  }

  &.medium {
    padding: 10px;
    width: 100%;
    font-size: 16px;

    @include iPhoneX {
      padding: 14px;
    }
  }

  &.large {
  }

  &.chevronLeft {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      flex: 1;
    }

    svg {
      path {
        stroke: $primaryOnBackground;
      }
    }
  }

  &:disabled {
    opacity: 0.5;
  }
}
